import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "platform-logs-table" }
const _hoisted_2 = { class: "px-6 py-4 bg-gradient-to-r from-gray-50 to-gray-100 border-b border-gray-200" }
const _hoisted_3 = { class: "flex flex-wrap items-center justify-between gap-3" }
const _hoisted_4 = { class: "flex flex-wrap gap-2" }
const _hoisted_5 = { class: "px-3 py-1.5 bg-green-100 text-green-700 rounded-full text-xs font-medium flex items-center gap-1.5" }
const _hoisted_6 = { class: "px-3 py-1.5 bg-red-100 text-red-700 rounded-full text-xs font-medium flex items-center gap-1.5" }
const _hoisted_7 = { class: "px-3 py-1.5 bg-yellow-100 text-yellow-700 rounded-full text-xs font-medium flex items-center gap-1.5" }
const _hoisted_8 = { class: "font-weight-medium text-xs" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "font-weight-medium text-xs" }
const _hoisted_11 = { class: "text-[10px] text--secondary" }
const _hoisted_12 = {
  key: 1,
  class: "text--disabled text-xs"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "font-weight-medium text-xs" }
const _hoisted_15 = { class: "text-[10px] text--secondary" }
const _hoisted_16 = {
  key: 1,
  class: "text--disabled text-xs"
}
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "font-weight-medium text-xs" }
const _hoisted_19 = { class: "text-[10px] text--secondary" }
const _hoisted_20 = {
  key: 1,
  class: "text--disabled text-xs"
}
const _hoisted_21 = {
  key: 0,
  class: "flex items-center gap-1"
}
const _hoisted_22 = { class: "font-semibold text-green-600 text-xs" }
const _hoisted_23 = { class: "text-[10px] text-gray-500" }
const _hoisted_24 = {
  key: 1,
  class: "text--disabled text-xs"
}
const _hoisted_25 = {
  key: 0,
  class: "flex items-center gap-1"
}
const _hoisted_26 = { class: "text-xs text-gray-600" }
const _hoisted_27 = {
  key: 1,
  class: "text--disabled text-xs"
}
const _hoisted_28 = {
  key: 0,
  class: "flex flex-col gap-0.5"
}
const _hoisted_29 = { class: "flex items-center gap-1" }
const _hoisted_30 = { class: "text-xs font-semibold text-blue-600" }
const _hoisted_31 = { class: "flex items-center gap-1 text-[10px]" }
const _hoisted_32 = {
  key: 1,
  class: "flex items-center gap-1"
}
const _hoisted_33 = { class: "text-xs font-semibold text-blue-600" }
const _hoisted_34 = {
  key: 2,
  class: "text--disabled text-xs"
}
const _hoisted_35 = ["title"]
const _hoisted_36 = {
  key: 0,
  class: "text-xs text-gray-700"
}
const _hoisted_37 = {
  key: 1,
  class: "text--disabled text-xs"
}
const _hoisted_38 = { class: "flex items-center gap-1" }
const _hoisted_39 = { class: "text-xs" }
const _hoisted_40 = { class: "text-xs" }
const _hoisted_41 = { class: "text-center py-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[3] || (_cache[3] = _createElementVNode("h3", { class: "text-lg font-semibold text-gray-800" }, "لیست لاگ‌های سیستم", -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_v_icon, {
              size: "14",
              color: "green"
            }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createTextVNode("mdi-check-circle", -1)
              ]))]),
              _: 1
            }),
            _createTextVNode(" موفق: " + _toDisplayString(_ctx.stats.byStatus.SUCCESS || 0), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_v_icon, {
              size: "14",
              color: "red"
            }, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                _createTextVNode("mdi-close-circle", -1)
              ]))]),
              _: 1
            }),
            _createTextVNode(" ناموفق: " + _toDisplayString(_ctx.stats.byStatus.FAILED || 0), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_v_icon, {
              size: "14",
              color: "orange"
            }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode("mdi-clock-outline", -1)
              ]))]),
              _: 1
            }),
            _createTextVNode(" در انتظار: " + _toDisplayString(_ctx.stats.byStatus.PENDING || 0), 1)
          ])
        ])
      ])
    ]),
    _createVNode(_component_v_card, {
      flat: "",
      class: "overflow-hidden"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_data_table, {
          headers: _ctx.headers,
          items: _ctx.logs,
          loading: _ctx.loading,
          "items-per-page": -1,
          "hide-default-footer": "",
          class: "compact-table"
        }, {
          [`item.type`]: _withCtx(({ item }) => [
            _createVNode(_component_v_chip, {
              color: _ctx.getTypeColor(item.type),
              size: "x-small",
              class: "text-xs"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.getTypeLabel(item.type)), 1)
              ]),
              _: 2
            }, 1032, ["color"])
          ]),
          [`item.status`]: _withCtx(({ item }) => [
            _createVNode(_component_v_chip, {
              color: _ctx.getStatusColor(item.status),
              size: "x-small",
              class: "text-xs"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.getStatusLabel(item.status)), 1)
              ]),
              _: 2
            }, 1032, ["color"])
          ]),
          [`item.action`]: _withCtx(({ item }) => [
            _createElementVNode("span", _hoisted_8, _toDisplayString(item.action), 1)
          ]),
          [`item.user`]: _withCtx(({ item }) => [
            (item.user)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, _toDisplayString(item.user.name), 1),
                  _createElementVNode("div", _hoisted_11, _toDisplayString(item.user.email), 1)
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_12, "—"))
          ]),
          [`item.admin`]: _withCtx(({ item }) => [
            (item.admin)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, _toDisplayString(item.admin.name), 1),
                  _createElementVNode("div", _hoisted_15, _toDisplayString(item.admin.email), 1)
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_16, "—"))
          ]),
          [`item.targetUser`]: _withCtx(({ item }) => [
            (item.targetUser)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, _toDisplayString(item.targetUser.name), 1),
                  _createElementVNode("div", _hoisted_19, _toDisplayString(item.targetUser.email), 1)
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_20, "—"))
          ]),
          [`item.amount`]: _withCtx(({ item }) => [
            (item.amount)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createVNode(_component_v_icon, {
                    size: "12",
                    color: "green"
                  }, {
                    default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                      _createTextVNode("mdi-cash", -1)
                    ]))]),
                    _: 1
                  }),
                  _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.formatAmount(item.amount)), 1),
                  _createElementVNode("span", _hoisted_23, _toDisplayString(item.currency || 'IRR'), 1)
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_24, "—"))
          ]),
          [`item.previousBalance`]: _withCtx(({ item }) => [
            (item.previousBalance)
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  _createVNode(_component_v_icon, {
                    size: "10",
                    color: "gray"
                  }, {
                    default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                      _createTextVNode("mdi-wallet-outline", -1)
                    ]))]),
                    _: 1
                  }),
                  _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.formatAmount(item.previousBalance)), 1)
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_27, "—"))
          ]),
          [`item.newBalance`]: _withCtx(({ item }) => [
            (item.newBalance && item.previousBalance)
              ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _createVNode(_component_v_icon, {
                      size: "10",
                      color: "blue"
                    }, {
                      default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                        _createTextVNode("mdi-wallet", -1)
                      ]))]),
                      _: 1
                    }),
                    _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.formatAmount(item.newBalance)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _createVNode(_component_v_icon, {
                      size: "8",
                      color: Number(item.newBalance) > Number(item.previousBalance) ? 'green' : 'red'
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(Number(item.newBalance) > Number(item.previousBalance) ? 'mdi-arrow-up' : 'mdi-arrow-down'), 1)
                      ]),
                      _: 2
                    }, 1032, ["color"]),
                    _createElementVNode("span", {
                      class: _normalizeClass(["", Number(item.newBalance) > Number(item.previousBalance) ? 'text-green-600' : 'text-red-600'])
                    }, _toDisplayString(_ctx.formatAmount(String(Math.abs(Number(item.newBalance) - Number(item.previousBalance))))), 3)
                  ])
                ]))
              : (item.newBalance)
                ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                    _createVNode(_component_v_icon, {
                      size: "10",
                      color: "blue"
                    }, {
                      default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                        _createTextVNode("mdi-wallet", -1)
                      ]))]),
                      _: 1
                    }),
                    _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.formatAmount(item.newBalance)), 1)
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_34, "—"))
          ]),
          [`item.description`]: _withCtx(({ item }) => [
            _createElementVNode("div", {
              class: "text-truncate text-xs",
              style: {"max-width":"250px"},
              title: item.description
            }, _toDisplayString(item.description), 9, _hoisted_35)
          ]),
          [`item.ipAddress`]: _withCtx(({ item }) => [
            (item.ipAddress)
              ? (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(item.ipAddress), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_37, "—"))
          ]),
          [`item.device`]: _withCtx(({ item }) => [
            _createElementVNode("div", _hoisted_38, [
              (item.device === 'mobile')
                ? (_openBlock(), _createBlock(_component_v_icon, {
                    key: 0,
                    size: "12"
                  }, {
                    default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                      _createTextVNode("mdi-cellphone", -1)
                    ]))]),
                    _: 1
                  }))
                : (item.device === 'tablet')
                  ? (_openBlock(), _createBlock(_component_v_icon, {
                      key: 1,
                      size: "12"
                    }, {
                      default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                        _createTextVNode("mdi-tablet", -1)
                      ]))]),
                      _: 1
                    }))
                  : (item.device === 'desktop')
                    ? (_openBlock(), _createBlock(_component_v_icon, {
                        key: 2,
                        size: "12"
                      }, {
                        default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                          _createTextVNode("mdi-monitor", -1)
                        ]))]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_v_icon, {
                        key: 3,
                        size: "12"
                      }, {
                        default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                          _createTextVNode("mdi-help-circle", -1)
                        ]))]),
                        _: 1
                      })),
              _createElementVNode("span", _hoisted_39, _toDisplayString(item.device || 'نامشخص'), 1)
            ])
          ]),
          [`item.createdAt`]: _withCtx(({ item }) => [
            _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.formatDate(item.createdAt)), 1)
          ]),
          [`item.actions`]: _withCtx(({ item }) => [
            _createVNode(_component_v_btn, {
              icon: "",
              size: "x-small",
              onClick: ($event: any) => (_ctx.$emit('view-details', item)),
              class: "hover:bg-blue-50 transition-colors"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  size: "16",
                  color: "blue"
                }, {
                  default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                    _createTextVNode("mdi-eye", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          "no-data": _withCtx(() => [
            _createElementVNode("div", _hoisted_41, [
              _createVNode(_component_v_icon, {
                size: "64",
                color: "grey lighten-1"
              }, {
                default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                  _createTextVNode("mdi-database-off", -1)
                ]))]),
                _: 1
              }),
              _cache[14] || (_cache[14] = _createElementVNode("p", { class: "text-xl font-semibold text-gray-400 mt-4" }, "هیچ لاگی یافت نشد", -1)),
              _cache[15] || (_cache[15] = _createElementVNode("p", { class: "text-sm text-gray-400 mt-2" }, "لطفاً فیلترهای جستجو را تغییر دهید", -1))
            ])
          ]),
          _: 2
        }, 1032, ["headers", "items", "loading"])
      ]),
      _: 1
    })
  ]))
}